import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

// context
import { useDropDown } from "../useDropDown";

// components
import CloseButton from "./CloseButton";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";

const PanelStyled = styled.ul`
    position: absolute;
    top: ${({ $top }) => convertPxToRem($top)};

    /* always 1 above the bottom triangle */
    z-index: ${({ $zIndex }) => $zIndex + 1};

    background-color: ${({ $isDarkMode }) =>
        $isDarkMode ? colors.secondary.orca : colors.primary.snow};
    width: ${({ $width }) => convertPxToRem($width)};
    padding: ${({ $padding }) => convertPxToRem($padding)};

    box-shadow: 0rem 0rem ${convertPxToRem(8)}
        ${({ $isDarkMode }) =>
            $isDarkMode ? `rgba(255, 255, 255, 1)` : `rgba(0, 0, 0, 0.35)`};

    ${({ $alignment }) => {
        let alignmentStyles = {
            left: "auto",
            right: "auto",
            transform: "none"
        };

        switch ($alignment) {
            case "center":
                alignmentStyles = {
                    ...alignmentStyles,
                    left: "50%",
                    transform: "translateX(-50%)"
                };
                break;
            case "right":
                alignmentStyles = {
                    ...alignmentStyles,
                    right: "0rem"
                };
                break;
            default:
                alignmentStyles = {
                    ...alignmentStyles,
                    left: "0rem"
                };
                break;
        }

        return css`
            left: ${alignmentStyles.left};
            right: ${alignmentStyles.right};
            transform: ${alignmentStyles.transform};
        `;
    }}
`;

// component
const Panel = ({ children }) => {
    const {
        isOpen,
        hasCloseButton,
        id,
        dropDownRef,
        alignment,
        zIndex,
        isDarkMode,
        top,
        width,
        padding
    } = useDropDown();
    return (
        <PanelStyled
            ref={dropDownRef}
            id={`${id}-dropdown-panel`}
            role="menu"
            aria-labelledby={`${id}-dropdown-trigger`}
            hidden={!isOpen}
            $alignment={alignment}
            $zIndex={zIndex}
            $isDarkMode={isDarkMode}
            $top={top}
            $width={width}
            $padding={padding}
        >
            {children}
            {hasCloseButton && <CloseButton />}
        </PanelStyled>
    );
};

export default Panel;

// prop-types
Panel.propTypes = {
    children: PropTypes.any
};
